/**
 * Created by muze on 7/24/2017 AD.
 */
import React from 'react';
import PropTypes from 'prop-types'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import omit from 'lodash/omit'

const FormSelect = ({
  label,
  value,
  onChange,
  options,
  disabled,
  style,
  ...props,
}) => {
  let arrayType = 0;
  if (options[0] && options[0].label) {
    arrayType = 1;
  }

  return (
    <SelectField
      disabled={disabled}
      floatingLabelText={label}
      value={value}
      onChange={(event, index, val) => onChange(val)}
      style={style}
      underlineDisabledStyle={{ display: 'none' }}
      {...omit(props, 'showButton', 'defaultLabel', 'hasDefault')}
    >
      {arrayType === 0 ?
        options.map(
          (item) => (
            <MenuItem key={item} value={item} primaryText={item} />
          ),
        )
        :
        options.map(
          (item) => (
            <MenuItem key={item.value} value={item.value} primaryText={item.label} />
          ),
        )
      }
    </SelectField>
  );
};

FormSelect.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  onChange: PropTypes.func,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  defaultLabel: PropTypes.string,
  hasDefault: PropTypes.bool,
  style: PropTypes.object,
};
FormSelect.defaultProps = {
  defaultLabel: 'Please select a value',
  options: [],
  hasDefault: true,
  disabled: false,
  style: {},
  onChange: () => {},
  label: '',
  value: '',
};

export default FormSelect;



// WEBPACK FOOTER //
// ./src/components/forms/bases/FormSelect.js